import Screen from './screen';
import template from './templates/splash.html';
export class SplashScreen extends Screen {
    constructor(uic) {
        super("splash", uic);
    }
    show(options) {
        this.uic.setOnboarding(this.name);
        this.element.show();
        this.uic.hideDownloadIcon();
        this.uic.toggleChatWindowVisibility(true);
    }
    hide() {
        this.element.hide();
    }
    bootstrapScreen(chatWindowElement) {
        chatWindowElement.append(template);
        this.element = $('#cbot-splash-chatwindow');
    }
    resizeEvent() {
    }
    ;
}
